<template>
  <v-dialog transition="dialog-top-transition" max-width="80%" persistent v-model="dialog_history">
    <template v-slot:default="">
      <v-card>

        <!-- Header -->
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Histórico do Protocolo</div>
            <div class="dialog-header__sub">{{ visualizacao.protocolo }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-chip small :color="statusColor(visualizacao.status)" dark class="mr-2" style="font-family:Inter;font-weight:600;font-size:0.72rem">
            {{ visualizacao.status }}
          </v-chip>
          <v-btn icon @click="$emit('close')"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="pa-6">

          <!-- Dados do Credor -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-domain</v-icon>
            Credor
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="visualizacao.empresa" label="Empresa"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.cpf_cnpj" label="CNPJ/CPF"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.email" label="E-mail"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field :value="moment(visualizacao.data_insercao).format('DD/MM/YYYY')" label="Data de Inserção"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Dados do Devedor -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-account-outline</v-icon>
            Devedor
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="visualizacao.devedor" label="Devedor"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.dev_cpfCnpj" label="CNPJ/CPF"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.valor_original" label="Valor Original"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.valor_vencido" label="Valor Vencido"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.especie" label="Espécie"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field :value="visualizacao.data_emissao" label="Data de Emissão"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="visualizacao.data_vencimento" label="Data de Vencimento"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Motivo / Observação -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-text-box-outline</v-icon>
            Baixa
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="visualizacao.motivo" label="Motivo"
                outlined readonly dense color="#0052A0"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="visualizacao.motivo_observacao" label="Observação"
                outlined readonly dense color="#0052A0" rows="3" auto-grow></v-textarea>
            </v-col>
          </v-row>

          <!-- Anexo -->
          <div class="dialog-section-label mt-2">
            <v-icon small color="#0052A0" class="mr-1">mdi-paperclip</v-icon>
            Anexo
          </div>
          <v-btn outlined rounded color="#0052A0" :disabled="!visualizacao.path_anexo" @click="downloadDocumento()" class="px-5 mb-4">
            <v-icon left small>mdi-download</v-icon>
            <span style="font-size:13px">Baixar Documento</span>
          </v-btn>

          <v-divider class="my-4"></v-divider>

          <!-- Coautores -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-account-multiple-outline</v-icon>
            Coautores
          </div>
          <v-data-table
            :items="visualizacao.coautores"
            dense hide-default-footer
            class="coautores-table elevation-0"
            :footer-props="{
              'items-per-page-text': 'Registros por página: ',
              'page-text': '{0}-{1} de {2}',
            }"
          >
            <template v-slot:header>
              <tr>
                <th>Código</th>
                <th>Nome/Razão Social</th>
                <th>CPF/CNPJ</th>
                <th>Observação</th>
                <th>Ações</th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.co_autor_id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.cpf_cnpj }}</td>
                <td>{{ item.observacao }}</td>
                <td>
                  <v-btn icon small color="#0052A0" @click="detalhesCoautor(item.co_autor_id)">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

        </v-card-text>

        <v-card-actions style="border-top:1px solid #f1f5f9;padding:12px 20px;">
          <v-spacer></v-spacer>
          <v-btn text rounded color="grey darken-1" @click="$emit('close')">
            <v-icon left small>mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- ══ DIALOG: Coautor detalhes ══ -->
      <v-dialog v-model="dialogCoautor" max-width="700">
        <v-card>
          <div class="dialog-header">
            <div class="dialog-header__icon-wrap">
              <v-icon color="#0052A0">mdi-account-outline</v-icon>
            </div>
            <div>
              <div class="dialog-header__title">Dados do Coobrigado</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogCoautor = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
          </div>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field v-model="coautor.name" label="Nome"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="coautor.cpf_cnpj" label="CNPJ/CPF"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="coautor.data_nascimento" label="Data Nascimento/Abertura"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="coautor.rg" label="RG"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="coautor.email" label="E-mail"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="coautor.observacao" label="Observação"
                  outlined readonly dense color="#0052A0"></v-text-field>
              </v-col>
            </v-row>

            <div class="dialog-section-label mt-2">
              <v-icon small color="#0052A0" class="mr-1">mdi-map-marker-outline</v-icon>
              Endereços
            </div>
            <v-data-table :items="coautor.enderecos" dense hide-default-footer class="coautores-table elevation-0">
              <template v-slot:header>
                <tr><th>Endereço</th><th>Nº</th><th>Bairro</th><th>CEP</th><th>Município</th><th>UF</th></tr>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.endereco }}</td><td>{{ item.numero }}</td>
                  <td>{{ item.bairro }}</td><td>{{ item.cep }}</td>
                  <td>{{ item.municipio }}</td><td>{{ item.uf }}</td>
                </tr>
              </template>
            </v-data-table>

            <div class="dialog-section-label mt-4">
              <v-icon small color="#0052A0" class="mr-1">mdi-phone-outline</v-icon>
              Telefones
            </div>
            <v-data-table :items="coautor.telefones" dense hide-default-footer class="coautores-table elevation-0">
              <template v-slot:item="{ item }">
                <tr><td>{{ item.telefone }}</td></tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions style="border-top:1px solid #f1f5f9;padding:12px 20px;">
            <v-spacer></v-spacer>
            <v-btn text rounded color="grey darken-1" @click="dialogCoautor = false">
              <v-icon left small>mdi-close</v-icon>Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </v-dialog>
</template>

<script>
import helper from "../mixins/helper";

export default {
  name: "HistoryComponent",
  mixins: [helper],
  props: {
    visualizacao: { default: {} },
    dialog_history: { default: false },
  },
  data: () => ({
    dialogCoautor: false,
    coautor: {},
  }),
  methods: {
    statusColor(status) {
      if (!status) return '#94a3b8';
      const s = status.toLowerCase();
      if (s.includes('ativo') || s.includes('notif')) return '#22c55e';
      if (s.includes('baixa')) return '#f59e0b';
      return '#64748b';
    },
    downloadDocumento() {
      const file = this.visualizacao.path_anexo;
      if (file) {
        this.$http.get("anexoprotocolo?documento=" + file, { responseType: "blob" }).then(
          (response) => {
            let blob = new Blob([response.data], { type: response.headers.map['content-type'] });
            window.open(window.URL.createObjectURL(blob));
          },
          (response) => { console.log(response); }
        );
      } else {
        alert('Documento inexistente');
      }
    },
    async detalhesCoautor(id) {
      const { data: result } = await this.$http.get(`devedor/${id}`);
      this.coautor = result;
      this.dialogCoautor = true;
    },
  },
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-wrap: wrap;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}

.dialog-section-label {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
  margin-bottom: 12px;
}

.coautores-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
}
.coautores-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
  color: #1e293b !important;
  font-weight: 400 !important;
}
</style>
